export default () => ({
  imgLogo: {
    width: 'auto',
    height: 50,
  },
  imgEmail: {
    width: 'auto',
    height: 130,
  },
});
